// just seems overkill to specify proptypes for an svg
/* eslint-disable react/prop-types */

import React from "react";

const UserIcon = () => (
  <svg width={30} height={30} viewBox="0 0 30 30" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 15.035C30 6.745 23.326 0 15.035 0 6.745 0 0 6.745 0 15.035S6.745 30 15.035 30 30 23.326 30 15.035zm-8.782-2.318c0-3.443-2.81-6.183-6.182-6.183-3.443 0-6.253 2.81-6.253 6.183a6.257 6.257 0 002.67 5.129c-2.74 1.054-4.919 3.232-6.394 5.901-2.038-2.318-3.302-5.41-3.302-8.711 0-7.307 5.972-13.28 13.279-13.28 7.306 0 13.208 5.973 13.208 13.28 0 3.302-1.265 6.393-3.302 8.711-1.405-2.67-3.654-4.847-6.394-5.901a6.257 6.257 0 002.67-5.129zM15.035 8.29a4.408 4.408 0 00-4.426 4.426 4.408 4.408 0 004.426 4.426 4.408 4.408 0 004.426-4.426 4.408 4.408 0 00-4.426-4.426zm0 10.68c3.864 0 6.956 2.74 8.571 6.042a12.832 12.832 0 01-8.571 3.232c-3.302 0-6.323-1.194-8.642-3.232 1.686-3.302 4.708-6.042 8.642-6.042z"
      fill="currentColor"
    />
  </svg>
);

const Alert = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 10C2.2385 10 0 7.7615 0 5C0 2.2385 2.2385 0 5 0C7.7615 0 10 2.2385 10 5C10 7.7615 7.7615 10 5 10ZM5 9C6.06087 9 7.07828 8.57857 7.82843 7.82843C8.57857 7.07828 9 6.06087 9 5C9 3.93913 8.57857 2.92172 7.82843 2.17157C7.07828 1.42143 6.06087 1 5 1C3.93913 1 2.92172 1.42143 2.17157 2.17157C1.42143 2.92172 1 3.93913 1 5C1 6.06087 1.42143 7.07828 2.17157 7.82843C2.92172 8.57857 3.93913 9 5 9ZM4.5 6.5H5.5V7.5H4.5V6.5ZM4.5 2.5H5.5V5.5H4.5V2.5Z" fill="#FF0000"/>
  </svg>
);

const ShowPassWord = () => (
  <svg width="20" height="18" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.984375 8C1.76771 3.73333 5.50687 0.5 10.0002 0.5C14.4935 0.5 18.2319 3.73333 19.016 8C18.2327 12.2667 14.4935 15.5 10.0002 15.5C5.50687 15.5 1.76854 12.2667 0.984375 8ZM10.0002 12.1667C11.1053 12.1667 12.1651 11.7277 12.9465 10.9463C13.7279 10.1649 14.1669 9.10507 14.1669 8C14.1669 6.89493 13.7279 5.83512 12.9465 5.05372C12.1651 4.27232 11.1053 3.83333 10.0002 3.83333C8.89514 3.83333 7.83533 4.27232 7.05393 5.05372C6.27253 5.83512 5.83354 6.89493 5.83354 8C5.83354 9.10507 6.27253 10.1649 7.05393 10.9463C7.83533 11.7277 8.89514 12.1667 10.0002 12.1667ZM10.0002 10.5C9.33717 10.5 8.70128 10.2366 8.23244 9.76777C7.7636 9.29893 7.50021 8.66304 7.50021 8C7.50021 7.33696 7.7636 6.70107 8.23244 6.23223C8.70128 5.76339 9.33717 5.5 10.0002 5.5C10.6632 5.5 11.2991 5.76339 11.768 6.23223C12.2368 6.70107 12.5002 7.33696 12.5002 8C12.5002 8.66304 12.2368 9.29893 11.768 9.76777C11.2991 10.2366 10.6632 10.5 10.0002 10.5Z" fill="#C4C4C4"/>
  </svg>
);

const HidePassWord = () => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.76663 3.94506L1.1608 1.34006L2.33996 0.160889L18.8391 16.6609L17.66 17.8392L14.9016 15.0809C13.436 16.0105 11.7356 16.5028 9.99996 16.5001C5.50663 16.5001 1.7683 13.2667 0.984131 9.00006C1.34249 7.05899 2.31882 5.2858 3.76746 3.94506H3.76663ZM12.2975 12.4767L11.0775 11.2567C10.6108 11.48 10.0864 11.553 9.57657 11.4657C9.0667 11.3784 8.59647 11.1351 8.23069 10.7693C7.86491 10.4036 7.6216 9.93332 7.53431 9.42345C7.44702 8.91358 7.52003 8.38918 7.7433 7.92256L6.5233 6.70256C5.99306 7.5038 5.75602 8.46367 5.85232 9.41963C5.94862 10.3756 6.37234 11.2689 7.05173 11.9483C7.73112 12.6277 8.62443 13.0514 9.58039 13.1477C10.5364 13.244 11.4962 13.007 12.2975 12.4767ZM6.64496 2.13339C7.68413 1.72506 8.81663 1.50006 9.99996 1.50006C14.4933 1.50006 18.2316 4.73339 19.0158 9.00006C18.7605 10.3881 18.1865 11.698 17.3391 12.8267L14.1225 9.61006C14.218 8.9664 14.1615 8.30931 13.9574 7.69143C13.7533 7.07356 13.4074 6.51207 12.9472 6.05195C12.4871 5.59182 11.9256 5.24586 11.3078 5.04178C10.6899 4.8377 10.0328 4.78117 9.38913 4.87672L6.64496 2.13422V2.13339Z" fill="#C4C4C4"/>
  </svg>
);

const NewHidePassWord = () => (
  <svg
    width='18'
    height='8'
    viewBox='0 0 18 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.222425 2.14572L2.2821 0.211016C2.33 0.168023 2.38474 0.125029 2.44633 0.0963672C2.7132 -0.0756067 3.06902 -0.0111165 3.2743 0.239679C3.9449 1.06372 6.35355 3.76514 9.00855 3.76514C11.6704 3.76514 14.0722 1.07089 14.7428 0.239679C14.8523 0.103533 15.0097 0.0175458 15.1876 0.00321465C15.3586 -0.0111165 15.5297 0.0462081 15.6597 0.160857C15.6803 0.175189 15.6939 0.18952 15.7145 0.203851L17.7741 2.13856C18.041 2.38935 18.0752 2.81212 17.8563 3.09158C17.7331 3.24922 17.5483 3.34237 17.3567 3.34237C17.1994 3.34237 17.042 3.27788 16.9256 3.1704L15.4408 1.78028C15.3586 1.70146 15.2355 1.70862 15.1534 1.79461C14.7223 2.26754 14.2638 2.70464 13.8053 3.09158C13.7232 3.16323 13.7027 3.28505 13.7643 3.3782L14.9618 5.25558C15.1602 5.57087 15.0781 5.99364 14.7839 6.20144C14.6744 6.2731 14.5512 6.31609 14.4212 6.31609C14.2022 6.31609 14.0038 6.20144 13.8806 6.01514L12.6968 4.15208C12.6352 4.05893 12.5189 4.03027 12.4231 4.08759C11.5814 4.58918 10.7466 4.91164 9.92548 5.05495C9.82284 5.06928 9.74757 5.16243 9.74757 5.26992V7.29777C9.74757 7.67755 9.46702 7.99283 9.11804 8C9.11119 8 9.10435 8 9.09751 8C8.92644 8 8.76905 7.93551 8.64588 7.80653C8.51587 7.67755 8.44744 7.50558 8.44744 7.31927V5.28425C8.44744 5.17676 8.37217 5.08361 8.26269 5.06928C7.48946 4.96179 6.68885 4.68234 5.89509 4.24524C5.79929 4.18791 5.67612 4.22374 5.62138 4.32406L4.53338 6.20861C4.41705 6.40924 4.20492 6.53822 3.97911 6.53822C3.83541 6.53822 3.69856 6.48806 3.58223 6.39491C3.3222 6.18711 3.25378 5.793 3.43169 5.49205L4.53338 3.57884C4.58812 3.48569 4.56759 3.36387 4.47863 3.29938C3.92437 2.86228 3.37695 2.34636 2.8569 1.78028C2.78163 1.69429 2.65161 1.69429 2.5695 1.76595L1.07777 3.1704C0.961447 3.28505 0.804062 3.34237 0.646679 3.34237C0.455082 3.34237 0.270325 3.24922 0.147156 3.09158C-0.0786572 2.82645 -0.0375996 2.39652 0.222425 2.14572Z'
      fill='#979797'
    />
  </svg>
);

const VolumeMute = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 4.49999V8.49999H3.16667L6.5 11.8333V1.16665L3.16667 4.49999H0.5ZM5.16667 4.38665V8.61332L3.72 7.16665H1.83333V5.83332H3.72L5.16667 4.38665ZM9.5 6.49999C9.5 5.31999 8.82 4.30665 7.83333" fill="#333333"></path>
  </svg>
);

const Volume = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.5 4.49999V8.49999H3.16667L6.5 11.8333V1.16665L3.16667 4.49999H0.5ZM5.16667 4.38665V8.61332L3.72 7.16665H1.83333V5.83332H3.72L5.16667 4.38665ZM9.5 6.49999C9.5 5.31999 8.82 4.30665 7.83333 3.81332V9.17999C8.82 8.69332 9.5 7.67999 9.5 6.49999ZM7.83333 0.65332V2.02665C9.76 2.59999 11.1667 4.38665 11.1667 6.49999C11.1667 8.61332 9.76 10.4 7.83333 10.9733V12.3467C10.5067 11.74 12.5 9.35332 12.5 6.49999C12.5 3.64665 10.5067 1.25999 7.83333 0.65332Z" fill="#333333"/>
  </svg>
);

const PlayAudio = () => (
  <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.44446 5.50003L0.500014 10.3611L0.500015 0.638916L7.44446 5.50003Z" fill="#333333"/>
  </svg>
);

const PlayAudioPause = () => (
  <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.25 8.875H2.75V0.125H0.25V8.875ZM5.25 0.125V8.875H7.75V0.125H5.25Z" fill="#333333"/>
  </svg>
);

const HamburgerMenuIcon = () => (
  <svg width={27} height={23} viewBox="0 0 27 23" fill="none">
    <path
      d="M1 1.5h25M1 11.5h25M1 21.5h25"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const ScrollToTopIcon = () => (
  <svg width={40} height={40} viewBox="0 0 40 40" fill="none">
    <path
      d="M0 20a20 20 0 1040 0 20 20 0 00-40 0zm21.756-9.832l7.579 7.58a2.38 2.38 0 01-2.596 3.884 2.382 2.382 0 01-.773-.516l-3.608-3.642v10.678a2.374 2.374 0 11-4.75 0V17.524l-3.587 3.583a2.382 2.382 0 01-3.368-3.368l7.579-7.579A2.358 2.358 0 0120 9.474h.076a2.367 2.367 0 011.68.694z"
      fill="currentColor"
    />
  </svg>
);

const MailIcon = () => (
  <svg width={25} height={17} viewBox="0 0 25 17" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.071 0C1.661 0 .5 1.152.5 2.55v11.9C.5 15.848 1.662 17 3.071 17H21.93c1.41 0 2.571-1.152 2.571-2.55V2.55C24.5 1.152 23.338 0 21.929 0H3.07zm.143 1.7h18.563L13.08 9.66c-.407.373-.772.373-1.178 0L3.214 1.7zm7.518 9.208L2.214 3.09v11.36c0 .486.368.85.857.85H21.93c.49 0 .857-.364.857-.85V3.09l-8.536 7.818c-.983.9-2.535.902-3.518 0z"
      fill="#fff"
    />
  </svg>
);

const AuthorsIcon = () => (
  <svg width={23} height={23} viewBox="0 0 23 23" fill="none">
    <path
      d="M10 3.121H3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 1.621a2.121 2.121 0 113 3l-9.5 9.5-4 1 1-4 9.5-9.5z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PointIcon  = React.forwardRef((props, ref)=>(
  <svg ref={ref} width="15" height="15" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3" cy="3" r="3" fill="#EA5504"/>
  </svg>
))

const LinksIcon = React.forwardRef((props, ref) => (
  <svg ref={ref} width={25} height={13} viewBox="0 0 25 13" fill="none">
    <path
      d="M15.749 1.816h3a5 5 0 110 10h-3m-6 0h-3a5.001 5.001 0 01-3.536-8.535A5 5 0 016.75 1.816h3M8.749 6.816h8"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

const ChevronUp = ({ clearSize }) => (
  <svg
    width={clearSize ? null : 17}
    height={clearSize ? null : 11}
    viewBox="0 0 17 11"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.081.653l7.286 7.787c.399.454.399 1.147 0 1.574-.4.426-1.048.426-1.472 0L8.333 3 1.77 10.014c-.4.426-1.073.426-1.472 0-.4-.427-.4-1.12 0-1.574L7.609.653c.4-.426 1.048-.426 1.472 0z"
      fill="currentColor"
    />
  </svg>
);

const ChevronDown = ({ clearSize }) => (
  <svg
    width={clearSize ? null : 17}
    height={clearSize ? null : 11}
    viewBox="0 0 17 11"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.58483 10.0135L0.299401 2.22683C-0.0998004 1.7735 -0.0998004 1.08016 0.299401 0.653496C0.698603 0.22683 1.34731 0.22683 1.77146 0.653496L8.33333 7.66683L14.8952 0.653496C15.2944 0.22683 15.9681 0.22683 16.3673 0.653496C16.7665 1.08016 16.7665 1.7735 16.3673 2.22683L9.05689 10.0135C8.65769 10.4402 8.00898 10.4402 7.58483 10.0135Z"
      fill="currentColor"
    />
  </svg>
);

const ChevronRight = ({ clearSize, color }) => (
    <svg width={clearSize ? null : 7} height={clearSize ? null : 12} viewBox='0 0 7 12' fill={color ? color : 'currentColor'}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.776 6.539l-5.45 5.245a.81.81 0 01-1.102 0 .739.739 0 010-1.06L5.134 6 .223 1.275a.739.739 0 010-1.06.811.811 0 011.101 0L6.776 5.48a.739.739 0 010 1.06z'
        />
    </svg>
)

const ChevronLeft = () => (
  <svg width={12} height={19} viewBox="0 0 12 19" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.384 8.225l9.344-7.9c.544-.433 1.376-.433 1.888 0s.512 1.136 0 1.596L3.2 9.036l8.416 7.115a1.021 1.021 0 010 1.597c-.512.432-1.344.432-1.888 0L.384 9.82c-.512-.433-.512-1.137 0-1.596z"
      fill="currentColor"
    />
  </svg>
);

const ChevronUpCarousel = () => (
  <svg width={30} height={18} viewBox="0 0 30 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3473 0.575997L29.4611 14.592C30.1796 15.408 30.1796 16.656 29.4611 17.424C28.7425 18.192 27.5748 18.192 26.8114 17.424L15 4.8L3.18862 17.424C2.47006 18.192 1.25748 18.192 0.53892 17.424C-0.179643 16.656 -0.179643 15.408 0.53892 14.592L13.6976 0.575997C14.4162 -0.192003 15.5838 -0.192003 16.3473 0.575997Z"
      fill="currentColor"
    />
  </svg>
);

const ChevronDownCarousel = () => (
  <svg width={30} height={18} viewBox="0 0 30 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3473 17.424L29.4611 3.408C30.1796 2.592 30.1796 1.344 29.4611 0.575999C28.7425 -0.192001 27.5749 -0.192001 26.8114 0.575999L15 13.2L3.18862 0.575996C2.47006 -0.192003 1.25749 -0.192003 0.538923 0.575996C-0.17964 1.344 -0.17964 2.592 0.538923 3.408L13.6976 17.424C14.4162 18.192 15.5838 18.192 16.3473 17.424Z"
      fill="currentColor"
    />
  </svg>
);

const ChevronRightCarousel = () => (
  <svg
    width={12}
    height={19}
    viewBox="0 0 12 19"
    fill="none"
    style={{ transform: "rotate(180deg)" }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.384 8.225l9.344-7.9c.544-.433 1.376-.433 1.888 0s.512 1.136 0 1.596L3.2 9.036l8.416 7.115a1.021 1.021 0 010 1.597c-.512.432-1.344.432-1.888 0L.384 9.82c-.512-.433-.512-1.137 0-1.596z"
      fill="currentColor"
    />
  </svg>
);

const ChevronLeftCarousel = () => (
  <svg width={12} height={19} viewBox="0 0 12 19" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.384 8.225l9.344-7.9c.544-.433 1.376-.433 1.888 0s.512 1.136 0 1.596L3.2 9.036l8.416 7.115a1.021 1.021 0 010 1.597c-.512.432-1.344.432-1.888 0L.384 9.82c-.512-.433-.512-1.137 0-1.596z"
      fill="currentColor"
    />
  </svg>
);

const ExampleCategoryIcon = () => (
  <svg width={21} height={22} viewBox="0 0 21 22" fill="none">
    <path
      d="M15.215 3h2.37c.628 0 1.23.21 1.675.586.444.375.694.884.694 1.414v14c0 .53-.25 1.04-.694 1.414-.444.375-1.047.586-1.675.586H3.369c-.628 0-1.23-.21-1.675-.586C1.25 20.04 1 19.53 1 19V5c0-.53.25-1.04.694-1.414C2.138 3.21 2.74 3 3.369 3h2.37"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.03 1H6.924C6.27 1 5.74 1.448 5.74 2v2c0 .552.53 1 1.184 1h7.108c.654 0 1.184-.448 1.184-1V2c0-.552-.53-1-1.184-1z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// please note that this icon is multi-colored and so we keep the original fill colours
// it will probably actually come from acoustic as an image
const ExampleHomepageCardIcon = () => (
  <svg width={36} height={50} viewBox="0 0 36 50" fill="none">
    <path
      d="M14.783 3.403A3.409 3.409 0 0118.19 0a3.398 3.398 0 013.398 3.403v.225h3.266a2.07 2.07 0 012.034 1.71h5.18a3.715 3.715 0 013.71 3.711v37.24A3.715 3.715 0 0132.069 50H3.711A3.715 3.715 0 010 46.29V9.05a3.715 3.715 0 013.71-3.711h5.774a2.07 2.07 0 012.033-1.711h3.266v-.225z"
      fill="#fff"
    />
    <path
      d="M18.19 0a3.409 3.409 0 00-3.407 3.403v.225h-3.266a2.07 2.07 0 00-2.033 1.71H3.711A3.715 3.715 0 000 9.05v37.24A3.715 3.715 0 003.71 50h28.358a3.715 3.715 0 003.71-3.71V9.05a3.715 3.715 0 00-3.71-3.711h-5.18a2.07 2.07 0 00-2.034-1.711h-3.266v-.225A3.398 3.398 0 0018.19 0zm-2.235 3.403a2.236 2.236 0 012.235-2.231c1.227 0 2.226.994 2.226 2.231v.225h-4.46v-.225zm10.97 3.108h5.143c1.4 0 2.54 1.139 2.54 2.538v37.24c0 1.4-1.14 2.54-2.54 2.54H3.711a2.542 2.542 0 01-2.54-2.54V9.05c0-1.4 1.14-2.538 2.54-2.538h5.737v1.796H5.117a2.15 2.15 0 00-2.149 2.148v34.42a2.15 2.15 0 002.149 2.149h25.545a2.15 2.15 0 002.148-2.149v-34.42a2.15 2.15 0 00-2.148-2.148h-3.737V6.511zm-.037 2.968h3.774c.539 0 .977.438.977.976v34.42a.977.977 0 01-.977.977H5.117a.977.977 0 01-.977-.977v-34.42c0-.538.438-.976.977-.976h4.368a2.07 2.07 0 002.032 1.706h13.337c1.017 0 1.86-.738 2.034-1.706zm-2.034-4.68a.9.9 0 01.899.901v3.412a.9.9 0 01-.899.901H11.517a.89.89 0 01-.897-.9V5.7a.9.9 0 01.897-.9h13.337z"
      fill="#5D6164"
    />
    <path
      d="M7.101 29.277c0 .324.263.586.586.586h20.405a.586.586 0 000-1.171H7.687a.586.586 0 00-.586.585zM28.092 32.939H7.687a.586.586 0 000 1.172h20.405a.586.586 0 000-1.172zM28.092 37.186H7.687a.586.586 0 000 1.172h20.405a.586.586 0 000-1.172zM28.092 41.433H7.687a.586.586 0 000 1.172h20.405a.586.586 0 000-1.172z"
      fill="#5D6164"
    />
    <path
      d="M11.96 26.93h11.86a.586.586 0 00.585-.586v-2.908c0-2.18-1.694-3.954-3.834-4.129a3.732 3.732 0 001.069-2.612 3.753 3.753 0 00-3.75-3.748 3.752 3.752 0 00-3.747 3.748c0 1.016.409 1.936 1.068 2.612-2.142.174-3.837 1.948-3.837 4.13v2.907c0 .324.262.586.586.586zm5.93-12.812a2.58 2.58 0 012.578 2.577 2.58 2.58 0 01-2.577 2.577 2.58 2.58 0 01-2.577-2.577 2.58 2.58 0 012.577-2.577zm-5.344 9.318a2.999 2.999 0 013-2.99h4.688c1.653 0 3 1.34 3 2.99v2.322H12.545v-2.322z"
      fill="#EA5506"
    />
  </svg>
);

const OncologyIcon = () => (
  <svg viewBox="0 0 33 33" fill="none">
    <circle
      cx={16.324}
      cy={16.324}
      r={15.774}
      stroke="currentColor"
      strokeWidth={1.1}
    />
    <circle
      cx={12.457}
      cy={23.626}
      r={2.457}
      stroke="currentColor"
      strokeWidth={1.1}
    />
    <circle
      cx={8.592}
      cy={15.464}
      r={2.027}
      stroke="currentColor"
      strokeWidth={1.1}
    />
    <circle
      cx={23.197}
      cy={17.181}
      r={4.605}
      stroke="currentColor"
      strokeWidth={1.1}
    />
    <circle
      cx={14.605}
      cy={13.745}
      r={1.168}
      stroke="currentColor"
      strokeWidth={1.1}
    />
    <circle
      cx={18.901}
      cy={9.45}
      r={1.168}
      stroke="currentColor"
      strokeWidth={1.1}
    />
  </svg>
);

const GastroIcon = () => (
  <svg viewBox="0 0 29 34" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.096 17.656V9.038c0-2.959 1.132-5.454 3.129-6.85a6.57 6.57 0 016.15-.612l1.857.747c1.738.502 3.6.358 5.239-.408 2.456-.956 4.82-.786 6.665.47 1.986 1.357 3.124 3.785 3.124 6.653v5.998c0 7.922-6.564 10.75-12.183 10.75h-2.784a.567.567 0 000 1.099h2.35c-.227 1.612-1.699 3.44-2.463 4.3l-1.736-2.677c-.894-1.465-.894-2.32-.894-2.365 0-1.923.611-3.32 1.77-4.125l.08-.056a5.013 5.013 0 012.83-.735h.887a8.96 8.96 0 003.836-.747h.034c.118-.044.23-.102.334-.17 1.873-1.036 2.863-2.909 2.863-5.529l-.045-4.746a2.83 2.83 0 00-.962-2.213c.755-.233 1.4-.731 1.816-1.404a.566.566 0 00-.226-.73.567.567 0 00-.741.222c-.028.05-.741 1.272-3.039 1.052h-.045a5.157 5.157 0 00-2.365.316l-1.635.69c-1.652.567-3.961-.43-4.011-.446a4.86 4.86 0 00-1.947-.407c-2.83 0-3.31-1.347-3.332-1.427A.566.566 0 004.598 6 3.167 3.167 0 006.67 7.85a3.337 3.337 0 00-1.2 2.784v4.968c0 .65.04 1.245.074 1.771.108 1.527.18 2.637-.753 4.068l-1.166 1.827-1.47-2.008a5.731 5.731 0 01-1.059-3.592v-.012zm5.659 1.025a2.788 2.788 0 01.86-2.15l.13-.12a.565.565 0 00-.758-.791l-.125.118c-.1.095-.194.195-.283.3v-3.751a3.475 3.475 0 012.263-.855c.652-.01 1.29.2 1.806.6a3.14 3.14 0 011.306 2.264c0 .9-.401 1.754-1.092 2.331a.353.353 0 00-.056.08c-.024.03-.048.062-.068.095a.648.648 0 000 .103.286.286 0 000 .096.36.36 0 000 .107.636.636 0 000 .102l.056.096c.014.03.03.058.051.085 0 0 .046.028.069.045.033.03.069.056.106.08h.086l.124.028h.102a.45.45 0 00.085 0 .436.436 0 00.107-.062l.074-.04 2.506-2.264c.047-.043.096-.083.148-.118a3.395 3.395 0 013.394-.475c.204.087.394.2.566.339a3.159 3.159 0 011.257 2.999 1.957 1.957 0 01-.792 1.454 7.692 7.692 0 01-3.554.752h-.888a6.101 6.101 0 00-3.463.951 2.796 2.796 0 01-4.017-2.393v-.006zm13.51-10.185c.523.334.822.923.782 1.54l.051 4.747c.023.9-.15 1.793-.503 2.62a4.223 4.223 0 00-1.698-3.31 3.502 3.502 0 00-.775-.47 4.56 4.56 0 00-4.25.408 1.993 1.993 0 01-.3-.204 3.156 3.156 0 01-1.255-2.982c.031-.619.36-1.183.882-1.516a.562.562 0 00.153-.103c.677.06 1.36-.021 2.003-.237l1.658-.702a3.892 3.892 0 013.253.21zM6.563 10.652c-.07-.789.277-1.557.917-2.026.437-.26.94-.392 1.449-.379h.056a4.08 4.08 0 011.493.305c.456.196.928.353 1.41.47a3.554 3.554 0 00-.685 1.698c0 .135 0 .265-.028.396a3.97 3.97 0 00-2.354-.753 4.687 4.687 0 00-2.263.612l.005-.323zM3.642 26.1a.566.566 0 00.566-.567v-1.13l1.516-2.388c.262-.39.477-.81.64-1.25.22.314.482.596.78.837a3.93 3.93 0 002.303.837 6.63 6.63 0 00-.956 3.65c0 .118-.057 1.204 1.064 3.004l2.025 3.123v1.172a.568.568 0 00.687.411.569.569 0 00.411-.41v-1.066c.595-.639 2.846-3.14 3.095-5.437 6.372-.243 12.59-3.927 12.59-11.848V9.039c0-3.241-1.32-5.991-3.605-7.559-2.16-1.471-4.894-1.697-7.7-.565H17a6.403 6.403 0 01-4.402.361L10.766.552c-2.603-.94-5.178-.673-7.169.742C1.334 2.894.004 5.718.004 9.039v8.63a6.795 6.795 0 001.244 4.158l1.845 2.552v1.132a.564.564 0 00.543.587h.006z"
      fill="currentColor"
    />
  </svg>
);

const CloseIcon = () => (
  <svg width={23} height={23} viewBox="0 0 23 23" fill="none">
    <path
      d="M2.377 21.238l18.86-18.86M2.378 2.377l18.86 18.861"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const Ellipsis = () => (
  <svg viewBox="0 0 18 4" fill="none">
    <path
      d="M9 3a1 1 0 100-2 1 1 0 000 2zM16 3a1 1 0 100-2 1 1 0 000 2zM2 3a1 1 0 100-2 1 1 0 000 2z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// a fill of 'white' seems to work better on focus of this icon in IE
const SearchIcon = () => (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="white">
    <path
      d="M15.7829 15.222L12.667 11.899C12.5264 11.749 12.3358 11.6657 12.1358 11.6657H11.6263C12.4889 10.4892 13.0014 9.0093 13.0014 7.39945C13.0014 3.56983 10.0919 0.466797 6.50096 0.466797C2.91008 0.466797 0.000488281 3.56983 0.000488281 7.39945C0.000488281 11.2291 2.91008 14.3321 6.50096 14.3321C8.01045 14.3321 9.39805 13.7855 10.5013 12.8656V13.4089C10.5013 13.6222 10.5794 13.8255 10.72 13.9755L13.8359 17.2985C14.1296 17.6118 14.6047 17.6118 14.8953 17.2985L15.7798 16.3552C16.0735 16.0419 16.0735 15.5353 15.7829 15.222ZM6.50096 11.6657C4.29143 11.6657 2.50067 9.75922 2.50067 7.39945C2.50067 5.04302 4.2883 3.1332 6.50096 3.1332C8.7105 3.1332 10.5013 5.03968 10.5013 7.39945C10.5013 9.75589 8.71363 11.6657 6.50096 11.6657Z"
      fill="#5D6164"
    />
  </svg>
);

const Play = ({ className }) => (
  <svg
    className={className || null}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m7.063 4.2596c-1.1394-0.58228-2.063-0.15176-2.063 0.95916v13.563c0 1.112 0.92523 1.5406 2.063 0.9592l13.083-6.6862c1.1393-0.5823 1.1377-1.5272 0-2.1086l-13.083-6.6862z"
      fill="#fff"
    />
  </svg>
);

const VideoIcon = () => (
  <svg width="21" height="21" fill="currentColor" viewBox="0 0 16 16">
    <path d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM1 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0z" />
    <path d="M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h7zm6 8.73V7.27l-3.5 1.555v4.35l3.5 1.556zM1 8v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1z" />
    <path d="M9 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM7 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
  </svg>
);

const ImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
    <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z" />
  </svg>
);

const DropdownArrowDown = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.240743 1.65079L4.06652 6.1142C4.42595 6.53353 5.05724 6.58209 5.47657 6.22267C5.51545 6.18934 5.55171 6.15308 5.58504 6.1142L9.41082 1.65079C9.77024 1.23147 9.72168 0.600166 9.30235 0.240743C9.12111 0.0853922 8.89027 0 8.65156 0L1 0C0.447715 0 0 0.447715 0 1C0 1.23871 0.0853922 1.46955 0.240743 1.65079Z"
      fill="#333333"
    />
  </svg>
);
const DownArrow = () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.03161 9.8093L0.746179 2.36491C0.346977 1.9315 0.346977 1.26864 0.746179 0.860729C1.14538 0.452817 1.79408 0.452817 2.21823 0.860729L8.78011 7.56578L15.342 0.860729C15.7412 0.452817 16.4148 0.452817 16.814 0.860729C17.2132 1.26864 17.2132 1.9315 16.814 2.36491L9.50366 9.8093C9.10446 10.2172 8.45576 10.2172 8.03161 9.8093Z"
      fill="#EA5504"
    />
  </svg>
);
const UpArrow = () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5287 0.860622L16.8141 8.30502C17.2133 8.73842 17.2133 9.40128 16.8141 9.80919C16.4149 10.2171 15.7662 10.2171 15.3421 9.80919L8.78019 3.10414L2.21832 9.80919C1.81911 10.2171 1.14546 10.2171 0.74626 9.80919C0.347057 9.40128 0.347057 8.73842 0.74626 8.30502L8.05664 0.860622C8.45584 0.45271 9.10454 0.45271 9.5287 0.860622Z"
      fill="#EA5504"
    />
  </svg>
);
const DropdownDownIcon = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.240743 5.81015L4.06652 1.34674C4.42595 0.927411 5.05724 0.87885 5.47657 1.23827C5.51545 1.2716 5.55171 1.30786 5.58504 1.34674L9.41082 5.81015C9.77024 6.22947 9.72168 6.86077 9.30235 7.22019C9.12111 7.37555 8.89027 7.46094 8.65156 7.46094L1 7.46094C0.447715 7.46094 0 7.01322 0 6.46094C0 6.22223 0.0853922 5.99139 0.240743 5.81015Z"
      fill="#333333"
    />
  </svg>
);
const NewDropdownDownIcon = () => (
  <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.91784 0.32L0.632409 8.10667C0.233208 8.56 0.233208 9.25333 0.632409 9.68C1.03161 10.1067 1.68031 10.1067 2.10447 9.68L8.66634 2.66667L15.2282 9.68C15.6274 10.1067 16.3011 10.1067 16.7003 9.68C17.0995 9.25333 17.0995 8.56 16.7003 8.10667L9.38989 0.32C8.99069 -0.106667 8.34199 -0.106667 7.91784 0.32Z" fill="#4B4C53"/>
</svg>
);

const StarIcon = () => (
  <svg
    fill="currentColor"
    stroke="#EA5504"
    width="39"
    height="39"
    viewBox="0 0 39 39"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.0833 2.45104L23.0045 14.5193L23.1168 14.8648H23.4801L36.1693 14.8648L25.9035 22.3233L25.6096 22.5369L25.7219 22.8823L29.6431 34.9506L19.3772 27.492L19.0833 27.2785L18.7894 27.492L8.52359 34.9506L12.4448 22.8823L12.5571 22.5369L12.2632 22.3233L1.99732 14.8648L14.6866 14.8648H15.0499L15.1621 14.5193L19.0833 2.45104Z" />
  </svg>
);

const PlayIcon = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="#979797"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.0315 0.129793C0.461816 -0.161345 0 0.053913 0 0.609373V7.3907C0 7.94671 0.462617 8.16101 1.0315 7.87028L7.57304 4.52719C8.14272 4.23605 8.14192 3.76362 7.57304 3.47289L1.0315 0.129793Z" />
  </svg>
);

const Clock = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6V12L15 15"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Calender = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6Z"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2V6"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2V6"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10H21"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Download = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 17V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V17"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12L12 16L16 12"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 2V16"
      stroke="#EA5504"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Location = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00442 0C4.56094 0 0.960938 2.66087 0.960938 7.04348C0.960938 11.1913 7.22181 17.5304 7.45659 17.7652C7.61311 17.9217 7.76963 18 8.00442 18C8.2392 18 8.39572 17.9217 8.55224 17.7652C8.78702 17.5304 15.0479 11.1913 15.0479 7.04348C15.0479 2.66087 11.4479 0 8.00442 0ZM8.00442 9.3913C6.67398 9.3913 5.65659 8.37391 5.65659 7.04348C5.65659 5.71304 6.67398 4.69565 8.00442 4.69565C9.33485 4.69565 10.3522 5.71304 10.3522 7.04348C10.3522 8.37391 9.33485 9.3913 8.00442 9.3913Z"
      fill="#EA5504"
    />
  </svg>
);

const Tick = () => (
  <svg
    width="42"
    height="40"
    viewBox="0 0 42 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="18.125" stroke="#EA5504" strokeWidth="3.75" />
    <path
      d="M11.3756 22.3744L16.6789 27.6777L29.0533 15.3033"
      stroke="#EA5504"
      strokeWidth="3.75"
      strokeLinecap="round"
    />
  </svg>
);

const OutlookLogo = () => (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    height="2500"
    image-rendering="optimizeQuality"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    viewBox="0 0 6876 6994"
    width="2457"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 779L4033 0l-14 6994L0 6160zm1430 3632c-305-357-390-918-244-1384 203-648 718-867 1149-717 246 86 465 293 582 610 56 152 86 326 88 503 4 318-106 692-324 953-335 400-903 441-1250 35zm314-339c-150-223-191-573-120-864 99-404 352-541 563-447 121 54 228 183 285 381 27 95 42 203 43 314 2 198-52 432-159 595-164 250-442 275-612 22zm2552-2598h2341c131 0 238 107 238 238v86L5035 3039c-24 16-83 62-132 93-72 47-77 38-153-5-117-65-319-203-455-297V1474zm2580 875v2504c0 200-164 365-365 365H4296V3366c133 88 310 204 419 271 88 54 104 79 202 22 45-26 89-60 119-80l1840-1229z"
      fill="#0072c6"
    />
  </svg>
);

const GmailLogo = () => (
  <svg
    height="2500"
    width="2500"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 49.4 512 399.4200000000001"
  >
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path
          d="M34.91 448.818h81.454V251L0 163.727V413.91c0 19.287 15.622 34.91 34.91 34.91z"
          fill="#4285f4"
        />
        <path
          d="M395.636 448.818h81.455c19.287 0 34.909-15.622 34.909-34.909V163.727L395.636 251z"
          fill="#34a853"
        />
        <path
          d="M395.636 99.727V251L512 163.727v-46.545c0-43.142-49.25-67.782-83.782-41.891z"
          fill="#fbbc04"
        />
      </g>
      <path
        d="M116.364 251V99.727L256 204.455 395.636 99.727V251L256 355.727z"
        fill="#ea4335"
      />
      <path
        d="M0 117.182v46.545L116.364 251V99.727L83.782 75.291C49.25 49.4 0 74.04 0 117.18z"
        fill="#c5221f"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const Bin = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.30692 17.1999C8.50872 17.1999 8.70243 17.1281 8.84612 17.0001C8.98982 16.8722 9.07196 16.6982 9.07478 16.516V10.945C9.07478 10.7611 8.99388 10.5847 8.84988 10.4546C8.70587 10.3245 8.51057 10.2515 8.30692 10.2515C8.10327 10.2515 7.90796 10.3245 7.76396 10.4546C7.61996 10.5847 7.53906 10.7611 7.53906 10.945V16.516C7.54188 16.6982 7.62402 16.8722 7.76772 17.0001C7.91141 17.1281 8.10511 17.1999 8.30692 17.1999Z" fill="#333333"/>
    <path d="M12.0003 17.1999C12.2021 17.1999 12.3958 17.1281 12.5395 17.0001C12.6832 16.8722 12.7653 16.6982 12.7681 16.516V10.945C12.7681 10.7611 12.6872 10.5847 12.5432 10.4546C12.3992 10.3245 12.2039 10.2515 12.0003 10.2515C11.7966 10.2515 11.6013 10.3245 11.4573 10.4546C11.3133 10.5847 11.2324 10.7611 11.2324 10.945V16.516C11.2352 16.6982 11.3174 16.8722 11.4611 17.0001C11.6048 17.1281 11.7985 17.1999 12.0003 17.1999Z" fill="#333333"/>
    <path d="M15.6927 17.1999C15.8945 17.1999 16.0882 17.1281 16.2319 17.0001C16.3756 16.8722 16.4577 16.6982 16.4605 16.516V10.945C16.4605 10.7611 16.3796 10.5847 16.2356 10.4546C16.0916 10.3245 15.8963 10.2515 15.6927 10.2515C15.489 10.2515 15.2937 10.3245 15.1497 10.4546C15.0057 10.5847 14.9248 10.7611 14.9248 10.945V16.516C14.9276 16.6982 15.0098 16.8722 15.1535 17.0001C15.2972 17.1281 15.4909 17.1999 15.6927 17.1999Z" fill="#333333"/>
    <path d="M21.2321 5.35806H16.3179L15.6857 3.44516C15.5457 3.02946 15.2622 2.66505 14.8768 2.40508C14.4913 2.14511 14.0239 2.00318 13.5429 2H10.4607C9.97965 2.00318 9.51229 2.14511 9.12682 2.40508C8.74134 2.66505 8.45791 3.02946 8.31786 3.44516L7.68571 5.35806H2.76786C2.56421 5.35806 2.3689 5.43113 2.2249 5.5612C2.0809 5.69127 2 5.86767 2 6.05161C2 6.23555 2.0809 6.41196 2.2249 6.54203C2.3689 6.67209 2.56421 6.74516 2.76786 6.74516H3.68214V20.0968C3.68591 20.6022 3.91059 21.0857 4.30726 21.4422C4.70392 21.7987 5.24045 21.9992 5.8 22H18.225C18.7864 21.9991 19.3245 21.7973 19.7215 21.4388C20.1185 21.0802 20.3419 20.5942 20.3429 20.0871V6.72258H21.2321C21.4358 6.72258 21.6311 6.64951 21.7751 6.51944C21.9191 6.38938 22 6.21297 22 6.02903C21.9996 5.93912 21.9792 5.85019 21.9402 5.76748C21.9011 5.68477 21.8441 5.60995 21.7726 5.54743C21.701 5.48491 21.6164 5.43595 21.5235 5.40343C21.4307 5.37091 21.3317 5.35548 21.2321 5.35806ZM9.80357 3.84194C9.84724 3.71387 9.93398 3.60126 10.0517 3.51975C10.1695 3.43824 10.3124 3.39188 10.4607 3.3871H13.5643C13.716 3.38594 13.8639 3.43028 13.9848 3.51317C14.1056 3.59606 14.1926 3.71282 14.2321 3.84516L14.725 5.35806H9.27143L9.80357 3.84194ZM18.8071 20.2387H18.7536C18.7136 20.3424 18.6395 20.4325 18.5412 20.4971C18.4429 20.5617 18.3251 20.5976 18.2036 20.6H5.8C5.6443 20.5975 5.49586 20.54 5.38642 20.44C5.27697 20.3399 5.21519 20.2052 5.21429 20.0645V6.72258H18.8071V20.2387Z" fill="#333333"/>
  </svg>
)

const NewDownArrow = ({ className }) => (
  <svg width="9" height="8" viewBox="0 0 9 8" fill="#333333" xmlns="http://www.w3.org/2000/svg" className={className || null}>
    <path d="M5.36603 7.5C4.98112 8.16667 4.01887 8.16667 3.63397 7.5L0.602886 2.25C0.217986 1.58333 0.699111 0.75 1.46891 0.75L7.53109 0.750001C8.30089 0.750001 8.78202 1.58333 8.39711 2.25L5.36603 7.5Z" />
  </svg>
)

const ArrowContactUs = (props) => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path fillRule="evenodd" clipRule="evenodd" d="M5.808 5.4491L1.136 9.82036C0.864 10.0599 0.447999 10.0599 0.191999 9.82036C-0.0640006 9.58084 -0.0640006 9.19162 0.191999 8.93713L4.4 5L0.191999 1.06287C-0.0640006 0.823353 -0.0640006 0.419161 0.191999 0.17964C0.447999 -0.0598812 0.864 -0.0598812 1.136 0.17964L5.808 4.56587C6.064 4.80539 6.064 5.19461 5.808 5.4491Z" fill="#EA5504"/>
  </svg>
)

const LeftArrow = () => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.1673 20H8.83398" stroke="#EA5504" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.4987 31.6668L8.83203 20.0002L20.4987 8.3335" stroke="#EA5504" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

const RightArrow = () => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.83398 20H32.1673" stroke="#EA5504" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.5 8.3335L32.1667 20.0002L20.5 31.6668" stroke="#EA5504" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
const ExternalSideNavIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="#333333" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.33333 5V6.66667H4.16667V15.8333H13.3333V11.6667H15V16.6667C15 16.8877 14.9122 17.0996 14.7559 17.2559C14.5996 17.4122 14.3877 17.5 14.1667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V5.83333C2.5 5.61232 2.5878 5.40036 2.74408 5.24408C2.90036 5.0878 3.11232 5 3.33333 5H8.33333ZM17.5 2.5V9.16667H15.8333V5.34417L9.33917 11.8392L8.16083 10.6608L14.6542 4.16667H10.8333V2.5H17.5Z" />
  </svg>
)

const CloseIconV2 = (props) => (
  <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.28387 6.50729L5.77489 3.99976L8.28194 1.49078C8.57107 1.20262 8.57107 0.739149 8.28291 0.450021L8.04997 0.216606C7.91309 0.0763642 7.72578 0 7.52887 0C7.52791 0 7.52791 0 7.52791 0C7.33099 0 7.14609 0.077325 7.00777 0.216126L4.49976 2.72606L1.99078 0.219007C1.7031 -0.0691602 1.24011 -0.0706012 0.950981 0.217566L0.717566 0.44858C0.576845 0.58642 0.5 0.773729 0.5 0.970163C0.5 1.16756 0.577325 1.35343 0.716125 1.49175L3.22606 3.99976L0.718526 6.50874C0.429399 6.7969 0.429399 7.26037 0.717566 7.55046L0.950501 7.7834C1.08834 7.92364 1.27517 8 1.47208 8C1.66804 8 1.85534 7.92172 1.99318 7.78388L4.50072 5.27442L7.00873 7.78099C7.15089 7.9246 7.34012 7.99712 7.52983 7.99712C7.71762 7.99712 7.90589 7.92556 8.04949 7.78243L8.28242 7.54998C8.42363 7.4131 8.49999 7.22579 8.49999 7.02888C8.50095 6.83196 8.42363 6.64609 8.28483 6.50729H8.28387Z" fill="white"/>
  </svg>
)

const PlayVideo = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" {...props}><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 18v-12l10 6-10 6z"/></svg>
)

const Radio = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none" {...props}>
    <circle cx="14.5" cy="14" r="13" fill="none" stroke="#EA5504" stroke-width="2"/>
  </svg>
)

const CheckedRadio = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...props}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2C20.6274 2 26 7.37258 26 14ZM28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14ZM14 22C18.4183 22 22 18.4183 22 14C22 9.58172 18.4183 6 14 6C9.58172 6 6 9.58172 6 14C6 18.4183 9.58172 22 14 22Z" fill="#EA5504"/>
  </svg>
)

const BookmarkOutlined = (props) => (
  <svg
    width='13'
    height='17'
    viewBox='0 0 13 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.25 1H1.75C1.33579 1 1 1.33579 1 1.75V15L6.43273 10.0612C6.47087 10.0265 6.52913 10.0265 6.56727 10.0612L12 15V1.75C12 1.33579 11.6642 1 11.25 1Z'
      fill='white'
      stroke='#767676'
      stroke-width='1.5'
    />
  </svg>
);

const BookmarkFilled = (props) => (
  <svg
    width='13'
    height='17'
    viewBox='0 0 13 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.25 1H1.75C1.33579 1 1 1.33579 1 1.75V15L6.43273 10.0612C6.47087 10.0265 6.52913 10.0265 6.56727 10.0612L12 15V1.75C12 1.33579 11.6642 1 11.25 1Z'
      fill='#EA5504'
      stroke='#EA5504'
      stroke-width='1.5'
    />
  </svg>
);

export {
  UserIcon,
  HamburgerMenuIcon,
  ScrollToTopIcon,
  MailIcon,
  AuthorsIcon,
  LinksIcon,
  ChevronUp,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  ChevronUpCarousel,
  ChevronDownCarousel,
  ChevronRightCarousel,
  ChevronLeftCarousel,
  ExampleCategoryIcon,
  ExampleHomepageCardIcon,
  OncologyIcon,
  GastroIcon,
  CloseIcon,
  Ellipsis,
  SearchIcon,
  Play,
  VideoIcon,
  ImageIcon,
  DropdownArrowDown,
  DownArrow,
  UpArrow,
  DropdownDownIcon,
  StarIcon,
  PlayIcon,
  Clock,
  Calender,
  Download,
  Location,
  Tick,
  GmailLogo,
  OutlookLogo,
  Bin,
  ArrowContactUs,
  LeftArrow,
  RightArrow,
  NewDownArrow,
  ExternalSideNavIcon,
  CloseIconV2,
  PlayVideo,
  PlayAudio,
  Volume,
  PlayAudioPause,
  VolumeMute,
  ShowPassWord,
  HidePassWord,
  NewHidePassWord,
  Alert,
  PointIcon,
  Radio,
  CheckedRadio,
  BookmarkOutlined,
  BookmarkFilled,
  NewDropdownDownIcon
};
